import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import LeadGeneration from "./pages/LeadGeneration";
import WebDevelopment from "./pages/WebDevelopment";
import SocialMediaMarketing from "./pages/SocialMediaMarketing";
import DigitalAds from "./pages/DigitalAds";
import MediaProduction from "./pages/MediaProduction";
import SEO from "./pages/SEO";
import About from "./pages/About";
import AISolutions from "./pages/AISolutions";
import AIEmailMarketing from "./pages/AIEmailMarketing";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services/lead-generation" element={<LeadGeneration />} />
          <Route path="/services/web-development" element={<WebDevelopment />} />
          <Route path="/services/social-media" element={<SocialMediaMarketing />} />
          <Route path="/services/digital-ads" element={<DigitalAds />} />
          <Route path="/services/media-production" element={<MediaProduction />} />
          <Route path="/services/seo" element={<SEO />} />
          <Route path="/about" element={<About />} />
          <Route path="/services/ai-solutions" element={<AISolutions />} />
          <Route path="/services/ai-email-marketing" element={<AIEmailMarketing />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
